import React, { FC } from "react";
import "./icon.css";
import { IconSkeleton } from "./icon.skeleton";

import {
  CarbonDioxide,
  Chart,
  Electricity,
  Facebook,
  Fishes,
  FishesThanks,
  Heart,
  LinkedIn,
  Microplastics,
  Money,
  Water,
} from "./icons";

export const icons = {
  water: [Water],
  money: [Money],
  microplastics: [Microplastics],
  heart: [Heart],
  "carbon-dioxide": [CarbonDioxide],
  electricity: [Electricity],
  chart: [Chart],
  linkedin: [LinkedIn],
  facebook: [Facebook],
  "fishes-thanks": [FishesThanks],
  fishes: [Fishes],
};

export type IconType = keyof typeof icons;

interface IconProps {
  className?: string;
  size?: "s" | "m" | "l" | "xl";
  type?: IconType;
  loading?: boolean;
}

/**
 * Icon component
 */
export const Icon: FC<IconProps> = ({
  type,
  size = "m",
  className,
  loading,
}) => {
  if (!type) {
    return null;
  }

  const [Icon, props = {}] = icons[type] as [React.FC<any>, any];

  return (
    <div className={`Icon ${size} ${className || ""}`}>
      {loading ? <IconSkeleton /> : <>{Icon && <Icon {...props} />}</>}
    </div>
  );
};
